export const BRANDING_OVERRIDES = {
  projectName: 'AltonMed',
  email: {
    sender: 'info@altonmed.com',
    replyTo: 'info@altonmed.com',
  },
};
